<template>
<div>
  <b-modal :id="this.ModalId" size="lg" :no-close-on-backdrop="true" :no-close-on-esc="true" scrollable centered :title="TitleWindow" :visible="!NotOpenByDefault ? true : false" @ok="this.emitEventOK" @hide="emitEventHide" :cancel-title="$t('Shared.BtnCancel')">
   <div id="ContainerPainAssessment">
    <b-row class="mt-2">
        <b-col md="12">
            <div class="text-center text-md-right mt-3 container-button">
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:VariantProp="'primary btn-login mx-2'"
                v-on:click="SaveOrEdit"
            />
            </div>
        </b-col>
    </b-row>
     <b-row>
        <b-col md="3" lg="3" sm="12">
            <MdSelect
                v-bind:Label="$t('Shared.WrittenBy')"
                data-field="therapist"
                v-bind:Options="therapistList"
                v-bind:FieldDescription="'fullName'"
                v-bind:FieldCode="'code'"
                v-bind:Model="painAssessment.TherapistCode"                       
                v-bind:Multiple="false"
                :Input="ChangeDropDownTherapistCode"
            />
        </b-col>
        <b-col md="3" lg="3" sm="12">
            <MdCheckBox
                v-bind:Label="$t('MdNote.Sign')"
                v-bind:Name="'checkbox-SignAssessment'"
                v-bind:ClassProp="'AlignCheck'"
                v-bind:CheckedValue="true"
                v-bind:UncheckedValue="false"
                v-model="painAssessment.IsSigned"
                v-on:change="onSignPassword"
            />
        </b-col>
     </b-row>
     <MdTitle v-bind:Text="$t('MdPainAssessmentNotesOutCome.ASSESSMENT')" v-bind:isSubtitle="true" v-bind:Name="'T_Assessment'"/>
     <b-row>
        <b-col md="3" lg="3" sm="12">
            <MdEdit 
                v-bind:Label="$t('Shared.Date')"
                v-bind:TypeProp="'date'" 
                v-bind:Name="'date'"
                v-bind:Min="'1900-01-01'"
                v-bind:Max="'2200-12-31'"
                v-model="painAssessment.AssessmentDate">                                     
            </MdEdit>
        </b-col>
        <b-col md="3" lg="3" sm="12">
            <MdEdit 
                v-bind:Label="$t('Incident.IncTime')"
                v-bind:TypeProp="'time'" 
                v-bind:Name="'time'"
                v-model="painAssessment.AssessmentTime">                                     
            </MdEdit>
        </b-col>
        <b-col md="3" lg="3" sm="12">
            <MdSelect
                v-bind:Label="$t('MdPainAssessmentNotesOutCome.PainIntensity')"
                data-field="PainScore"
                v-bind:Options="painIntensityList"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'value'"
                v-bind:Model="painAssessment.PainIntensity"                       
                v-bind:Multiple="false"
                :Input="ChangeDropDownPainScore"
            />
        </b-col>
        <b-col md="3" lg="3" sm="12">
            <MdEdit 
                v-bind:Label="$t('MdPainAssessmentNotesOutCome.PainLocation')"
                v-bind:TypeProp="'text'" 
                v-bind:Name="'Location'"
                v-model="painAssessment.Location"
                v-bind:Id="'input_location_id'">                                     
            </MdEdit>
        </b-col>
     </b-row>
     <b-row>
        <b-col md="3" lg="3" sm="12">
            <MdSelect
                v-bind:Label="$t('MdPainAssessmentNotesOutCome.PainType')"
                data-field="Character"
                v-bind:Options="charactertList"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'value'"
                v-bind:Model="painAssessment.PainCharacter"                       
                v-bind:Multiple="false"
                :Input="ChangeDropDownCharacter"
            />
        </b-col>
        <b-col md="3" lg="3" sm="12">
            <MdSelect
                v-bind:Label="$t('Shared.Frequency')"
                data-field="Frequency"
                v-bind:Options="frequencyList"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'value'"
                v-bind:Model="painAssessment.Frequency"                       
                v-bind:Multiple="false"
                :Input="ChangeDropDownFrequency"
            />
        </b-col>
        <b-col md="3" lg="3" sm="12">
            <MdEdit 
                v-bind:Label="$t('MdPainAssessmentNotesOutCome.Duration')"
                v-bind:TypeProp="'text'" 
                v-bind:Name="'Duration'"
                v-model="painAssessment.Duration">                                     
            </MdEdit>
        </b-col>
     </b-row>
     <MdTitle v-bind:Text="$t('MdPainAssessmentNotesOutCome.Interventions')" v-bind:isSubtitle="true" v-bind:Name="'T_Interventions'"/>
     <b-row>
      <b-col md="4" lg="4" sm="12">       
              <MdCheckListBox2 
                v-model="painAssessment.Intervention"
                v-bind:OnChangeProp="OnChangeIntervention"
                v-bind:Options="interventionList"
                v-bind:Height="'150px'"
                v-bind:columnCount="2"
                :textField="'name'"
                :valueField="'code'"> 
              </MdCheckListBox2>
    </b-col>
    </b-row>
     <b-row>       
        <b-col md="3" lg="3" sm="12">
            <MdEdit 
                v-bind:Label="$t('MdPainAssessmentNotesOutCome.OtherInterventions')"
                v-bind:TypeProp="'text'" 
                v-bind:Name="'Other'"
                v-model="painAssessment.OtherIntervention">                                     
            </MdEdit>
        </b-col>
        <!-- 
        <b-col md="3" lg="3" sm="12">
            <MdEdit 
                v-bind:Label="$t('Incident.IncTime')"
                v-bind:TypeProp="'number'" 
                v-bind:Name="'Time'"
                v-model="painAssessment.InterventionTime">                                     
            </MdEdit>
        </b-col>
        -->
     </b-row>
     <MdTitle v-bind:Text="$tc('Shared.Note', 2)" v-bind:isSubtitle="true" v-bind:Name="'T_Notes'"/>
     <b-row>
        <b-col md="12" lg="12" sm="12">
            <MdMemo
                v-bind:Name="'textarea_notes'"
                v-bind:Rows="'3'"
                v-bind:MaxRows="'6'"
                v-bind:MaxLength="'500'"
                v-model="painAssessment.Notes"
            />
        </b-col>
     </b-row>
   </div>

  </b-modal>
  <MdPasswordDlg v-if="showSignPassword"
    v-bind:UserId="UserId"
    v-bind:ShowPopup="showSignPassword"
    v-bind:EmployeeCode="this.$store.state.employeeCode"
    @getModalPassword="onModalPasswordResult($event)"
  />
 </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import LocalStorage from '@/services/storage.service';
import Utils from '@/common/utils.js'
import EnumService from "@/services/enum.service";
import GlobalService from '@/services/global.service' 
import TherapistService from '@/services/therapist.service'
import { EventBus } from '@/event-bus.js';

export default {
  name: 'PainAssessmentNotes', 
  mixins: [ShowMessage, DBFunctions,LocalStorage],
  props: {
     ModalId: String,
     TitleWindow: String,
     NotOpenByDefault:Boolean,
     MarsParam:Object
   },   
  data() {
    return {
      ShowMessageIsEmpty:false,
      Loading:true,
      UserId:LocalStorage.getUserId(),
      parameter:{
        PageNumber : 0,
        PageSize:0 ,       
      },
      // fields: [
      //   { key: 'allergy', sortable: true, label: 'Allergy', class: 'text-rigth' },                  
      //   ],
      pageOptions: [5, 10, 15 ],
      totalRows: 0,
      currentPage: 1,
      perPage: 5,
      items: [],
      selected: [],
      Header:{}, 
      isReadOnly: false,
      therapistList: [],
      charactertList: EnumService.Characterts,
      frequencyList: EnumService.Frequencys,
      interventionList: EnumService.Interventions,
      painAssessment: {
        TherapistCode:"",
        IsSigned:false,
        AssessmentDate:null,
        AssessmentTime:null,
        PainIntensity:null,
        Location:"",
        PainCharacter:"",
        Duration:"",
        Frequency:"",
        Intervention:[],
        OtherIntervention:"",
        InterventionTime:null,
        Notes:"",
      },
      showSignPassword: false,
      pendingChanges: false,
      clickOK: false,
      painIntensityList: [
        {"name":0, "value":0},
        {"name":1, "value":1},
        {"name":2, "value":2},
        {"name":3, "value":3},
        {"name":4, "value":4},
        {"name":5, "value":5},
        {"name":6, "value":6},
        {"name":7, "value":7},
        {"name":8, "value":8},
        {"name":9, "value":9},
        {"name":10, "value":10},
      ]
    }
  },

  methods: {
    emitEventOK(){ 

      let param = this.getTextResult()

      this.$emit('getCodeConditionOK', param);  
      },

      emitEventHide(){
      },

      ResetProps(){
        this.parameter.SearchCriteria = '';
      },

      processResult(PainIntensity,Location,PainCharacter,Duration,Intervention,OtherIntervention,Notes) {
        let textResult = "";

        const hasData =
          PainIntensity || Location || PainCharacter || Duration ||
          (Intervention && Intervention.length > 0) || OtherIntervention || Notes;

        if (hasData) {
          textResult += "SCALE RESULTS\n";
          if (PainIntensity) textResult += `Pain Intensity: ${PainIntensity}\n`;
          if (Location) textResult += `Pain Location: ${Location}\n`;
          if (PainCharacter) textResult += `Pain Type: ${PainCharacter}\n`;
          if (Duration) textResult += `Duration: ${Duration}\n`;

          if (Intervention && Intervention.length > 0) {
            let cleanedIntervention = Intervention.join(",");
            textResult += `Interventions: ${cleanedIntervention}`;
            if (OtherIntervention) {
              textResult += `, ${OtherIntervention}\n`;
            } else {
              textResult += `\n`;
            }
          } else if (OtherIntervention) {
            textResult += `Other Interventions: ${OtherIntervention}\n`;
          }

          if (Notes) {
            textResult += `Notes: ${Notes}\n`;
          }
        }

        return textResult;
      },

      getTextResult() {
        return this.processResult(this.painAssessment.PainIntensity,this.painAssessment.Location,this.painAssessment.PainCharacter,
                                  this.painAssessment.Duration,this.painAssessment.Intervention,this.painAssessment.OtherIntervention,
                                  this.painAssessment.Notes) 
      },

    ChangeDropDownTherapistCode(item){
        this.painAssessment.TherapistCode = item ? item.code : '';
    },

    ChangeDropDownCharacter(item){
        this.painAssessment.PainCharacter = item ? item.value : '';
    },

    ChangeDropDownFrequency(item){
        this.painAssessment.Frequency = item ? item.value : '';
    },

    OnChangeIntervention(){

    },

    ChangeDropDownPainScore(item) {
      this.painAssessment.PainIntensity = item && item.value ? item.value : ''
    },

    getDateTime() { 
         GlobalService.getDateTime()
            .then((response) => {      
               if (response.data) {
                  if (!this.VitalSId) 
                    this.painAssessment.AssessmentDate = this.formatterDate(response.data);
                    this.painAssessment.AssessmentTime = Utils.formatTimeHm(response.data)
               }  
         })
         .catch(error => {
            if (error.response) {
               this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
         }); 
      },

    SetTherapists(){     
        if(this.UserId){
          var l = this.therapistList.length;
          for(var i = 0; i < l; i++){
            if(this.therapistList[i].code.toLowerCase() == this.UserId.toLowerCase()){
              this.painAssessment.TherapistCode = this.therapistList[i].code;
            }
          }
        }      
    },

    async getTherapists(){
        await TherapistService.getAllTherapist(this.UserId)
          .then((response) => { 
            if(response.data && response.data.length > 0){   
              let arr = response.data;
              for(var i = 0; i<arr.length; i++){
                arr[i].fullName = arr[i].firstName+" "+arr[i].lastName;
              }
              this.therapistList = arr;
            }
          })
          .catch(error => {
            if (error.response) {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
            } 
          });  
      },

      onSignPassword(value) {
        if(this.painAssessment.TherapistCode) {
            this.showSignPassword = value;
        } else {
            this.painAssessment.IsSigned = false
            this.showMessage(this.$tc('Msg.Error'),this.$t('MdPainAssessmentNotesOutCome.TheraRequiredMsg'),"error");
        }
      },

      onModalPasswordResult(result) {
        if(result.status != true) {
          this.showMessage(this.$tc('Msg.Error'),result,"error");
        }
        this.showSignPassword = false;
      },

    pageChanged (page) {            
      this.currentPage = page; 
    },

    PerPageFunction(perpage){
      this.perPage = perpage;  
    },

    onRowSelected(items) {    
     this.selected = items;
    },

      onCodeDescriptionOk(result){
        this.Allergy.allergyCode = result.code;
        this.getLookupFieldsDesc(result.code);
      },

      formatterDate(value){
         return Utils.formatterDate(value);
      },

      SaveOrEdit(){
        if(this.painAssessment.IsSigned) { 
          this.pendingChanges = false;          
        } else {
            this.showMessage(this.$tc('Msg.Error'),
                          this.$t('MdPainAssessmentNotesOutCome.SingBeforeMsg'),"error");
        }
      },

      beforeWindowUnload(e) {
			if (this.pendingChanges) {
				e.preventDefault()
				e.returnValue = ''	
			}
		}
  },

  async mounted() {
    await this.getTherapists()
    this.SetTherapists()
    this.getDateTime()
    this.$emit('load', this.Loading); 
  },

  created () {
       EventBus.$on("onChanged", function (e) {       
          this.pendingChanges = e.Changed
     }.bind(this));
     window.addEventListener('beforeunload', this.beforeWindowUnload)
    },

    beforeDestroy () {
      window.removeEventListener('beforeunload', this.beforeWindowUnload)
    },
};

</script>